function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React from 'react';
import PropTypes from 'prop-types';
import AbstractInput from '../AbstractInput';
import AbstractCheckbox from '../Checkbox/AbstractCheckbox';
import { classNamesFor } from '../utils/classNames';
var cx;
/**
 * The Radio component provides a stylable alternative to the radio element. It is used
 * to select only one choice amongst many choices. This radio component is implemented as a
 * controlled component which means that state is managed outside of the component.
 *
 * - [React controlled inputs](https://reactjs.org/docs/forms.html#controlled-components)
 * - [MDN docs for radio](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input/radio)
 *
 * ## Related Components
 * - [Checkbox](../Checkbox/README.md)
 * - [RadioGroup](../RadioGroup/README.md)
 *
 * ## Usage
 *
 *```jsx
 *<RadioGroup
 *  variant="toggle"
 *  name="myField"
 *  value="1"
 *  onChange={({ target }) => console.log(target.name, target.value)}>
 *  <Radio
 *    label="Option 1"
 *    value="1"
 *  >
 *    Option 1
 *  </Radio>
 *  <Radio
 *    value="2"
 *  />
 *   Option 2
 *  </Radio>
 *</RadioGroup>
 *```
 *
 * With Content
 *
 * ```jsx
 * <RadioGroup variant="content" name="myField" value="1">
 *    <Radio className="inlayed p-xs" value="1">
 *      {(checked) => (
 *        <div className="l-space-repel">
 *          <Player {...playerProps} />
 *          <span className={`user-select ${checked ? 'user-select--selected' : ''} round`}>
 *            {checked && <Icon type="check" size="small" />}
 *          </span>
 *        </div>
 *      )}
 *    </Radio>
 *    <Radio className="inlayed p-xs" value="2">
 *      {(checked) => (
 *        <div className="l-space-repel">
 *          <Player {...playerProps} />
 *          <span className={`user-select ${checked ? 'user-select--selected' : ''} round`}>
 *            {checked && <Icon type="check" size="small" />}
 *          </span>
 *        </div>
 *      )}
 *    </Radio>
 * ```
 *
 * ## Props
 */

var Radio = /*#__PURE__*/function (_AbstractInput) {
  _inherits(Radio, _AbstractInput);

  var _super = _createSuper(Radio);

  function Radio() {
    _classCallCheck(this, Radio);

    return _super.apply(this, arguments);
  }

  _createClass(Radio, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          qa = _this$props.qa,
          checked = _this$props.checked,
          children = _this$props.children,
          className = _this$props.className,
          ctaType = _this$props.ctaType,
          disabled = _this$props.disabled,
          id = _this$props.id,
          size = _this$props.size,
          variant = _this$props.variant,
          node = _this$props.node;
      var isFocused = this.state.isFocused;
      return /*#__PURE__*/React.createElement(AbstractCheckbox, _extends({}, this.props, {
        id: this.id || id,
        onFocus: this.onFocus,
        onBlur: this.onBlur,
        qa: qa,
        ref: node,
        styleHooks: Radio.getClassName({
          checked: checked,
          children: children,
          className: className,
          ctaType: ctaType,
          disabled: disabled,
          isFocused: isFocused,
          size: size,
          variant: variant
        }),
        type: "radio"
      }));
    }
  }]);

  return Radio;
}(AbstractInput);

_defineProperty(Radio, "getClassName", function (props) {
  return AbstractCheckbox.getClassName(cx, 'radio')(props);
});

_defineProperty(Radio, "useClassNames", function (classNames) {
  Radio.classNames = classNames;
});

Radio.defaultProps = {
  qa: '',
  checked: false,
  children: null,
  className: '',
  ctaType: '',
  dataTrackClick: null,
  disabled: false,
  id: '',
  name: '',
  node: null,
  onBlur: function onBlur() {},
  onChange: function onChange() {},
  onFocus: function onFocus() {},
  size: 'medium',
  value: '',
  variant: 'standard'
};
Radio.propTypes = {
  id: PropTypes.string,

  /**
   * Presentational variants
   */
  variant: PropTypes.oneOfType([PropTypes.oneOf(['content', 'standard', 'text-list', 'text-list-2', 'toggle']), PropTypes.string]),

  /**
   * The qa selector used for testing
   */
  qa: PropTypes.string,

  /**
   * The size of the quick action button
   */
  size: PropTypes.oneOf(['small', 'medium', 'large']),

  /**
   * The type of button in design language
   */
  ctaType: PropTypes.oneOf(['', 'primary', 'secondary', 'alt-secondary', 'purchase']),

  /**
   * Whether the radio is initially checked
   */
  checked: PropTypes.bool,

  /**
   * Allows adding a custom class or series of classes on the component
   * useful for setting margin or padding
   */
  className: PropTypes.string,

  /**
   * forwarded ref to attach to the checkbox element
   */
  node: PropTypes.oneOfType([PropTypes.node, PropTypes.func]),

  /**
   * The name associated with the controls value. Connected Radios
   * must all share the same name. It's recommended to use a RadioGroup
   * instead of individually setting names for each control
   */
  name: PropTypes.string,

  /**
   * The value to be chosen
   */
  value: PropTypes.string,

  /**
   * **DEPRECATED** Use trackClick instead
   * data attribute for click tracking
   */
  dataTrackClick: PropTypes.string,

  /**
   * The spec id identifying the interaction
   */
  trackClick: PropTypes.string,

  /**
  * Serialized json data of context specific telemetry data
  */
  telemetryMeta: PropTypes.string,

  /**
   * Whether the radio control is disabled or not
   */
  disabled: PropTypes.bool,

  /**
   * event callback to be called when the checked state changes
   */
  onChange: PropTypes.func,

  /**
   * event callback to be called when the checkbox is focused
   */
  onFocus: PropTypes.func,

  /**
   * event callback to be called when the checkbox is blurred
   */
  onBlur: PropTypes.func,

  /**
   * Render function receiving the internal checked state
   * used to convert any UI into a radio
   */
  children: PropTypes.oneOfType([PropTypes.func, PropTypes.node])
};
cx = classNamesFor(Radio);
export default Radio;